// extracted by mini-css-extract-plugin
module.exports = {"component":"TeamsFormPage_component__2yMAu","content":"TeamsFormPage_content__1Gr2U","header":"TeamsFormPage_header__3u6zm"};